<template>
    <div
            class="color-block color-block_blue"
            :class="{'color-block__mobile': $vuetify.breakpoint.xsOnly}"
    >
        <div class="color-block__head">
            <div
                    class="color-block__head-wrap"
                    :class="{
                        'color-block__head-wrap_fold': isFold,
                        'color-block__head-wrap_active': isOpen
                    }"
                    @click="clickHead()"
            >
                <div class="color-block__label">{{ label }}</div>
                <div v-if="isFold" class="color-block__switch">
                    <v-icon>mdi-chevron-down</v-icon>
                </div>
            </div>
        </div>
        <div
                class="color-block__content"
                :style="{
                    'max-height': isOpen || !isFold ? '200px' : '0',
                }"
        >
            <div class="color-block__content-wrap">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            label: {type: String, default: null},
            isFold: {type: Boolean, default: false}
        },
        data() {
            return {
                isOpen: false
            };
        },
        methods: {
            clickHead() {
                if (!this.isFold) return;
                this.isOpen = !this.isOpen;
            }
        }
    }
</script>

<style lang="scss">
    .color-block {
        margin: 8px -8px;
        padding: 5px 8px;

        &.color-block_green {
            background-color: #e4efe58c;
        }
        &.color-block_gray {
            background-color: #eee;
        }
        &.color-block_blue {
            background-color: #ede9ff;
        }
        &.color-block__mobile {
            margin: 8px -10px;

            .color-block__head {
                padding-top: 5px;
                padding-bottom: 5px;
            }
        }
        .color-block__head {
            display: flex;
            user-select: none;
        }
        .color-block__head-wrap {
            width: 100%;
            height: 19px;
            max-height: 30px;
            display: flex;
            align-items: center;
            transition: height 300ms;

            &.color-block__head-wrap_fold {
                cursor: pointer;
            }
            &.color-block__head-wrap_active {
                height: 30px;
                max-height: 30px;

                .v-icon {
                    transform: rotate(180deg);
                }
            }
        }
        .color-block__content {
            transition: max-height 500ms;
            overflow: hidden;
        }
        .color-block__content-wrap {
            padding: 5px 0;
        }
        .color-block__switch {
            margin-left: 5px;
            margin-top: -1px;

            .v-icon {
                height: 12px;
            }
        }
    }
</style>